import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CabinIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cabin"}/>
}
